export default __webpack_public_path__ + "static/media/ScanSurgery.634b54fb.svg";